import assets from './assets';

export default {
  start: {
    video: assets.startVideo,
  },
  end: {
    withBullets: 3,
  },
  scenarios: [
    {
      key: 'scenarioA',
      steps: [
        {
          key: 'stepA1',
          withNextSteps: false,
          withMore: false,
          withBody: false,
          withBullets: [
            {
              key: 'bullet1',
              goTo: 'stepA2',
            },
            {
              key: 'bullet2',
              goTo: 'stepA3',
            },
          ],

          image: assets.scenarioAstep1,
          hotspots: [
            { x: 103, y: 390, goTo: 'stepA2' },
            { x: 1025, y: 500, goTo: 'stepA3' },
          ],
        },
        {
          key: 'stepA2',
          withBullets: 4,
          video: assets.scenarioAstep2,
        },
        {
          key: 'stepA3',
          withBullets: 3,
          video: assets.scenarioAstep3,
        },
      ],
    },
    {
      key: 'scenarioB',
      steps: [
        {
          key: 'stepB1',
          withNextSteps: false,
          withBullets: [
            {
              key: 'bullet1',
              goTo: 'stepB2',
            },
            {
              key: 'bullet2',
              goTo: 'stepB3',
            },
          ],
          image: assets.scenarioBstep1,
          hotspots: [
            { x: 470, y: 775, goTo: 'stepB2' },
            { x: 430, y: 350, goTo: 'stepB3' },
          ],
        },
        {
          key: 'stepB2',
          withBullets: 3,
          video: assets.scenarioBstep2,
        },
        {
          key: 'stepB3',
          withBullets: 3,
          video: assets.scenarioBstep3,
        },
      ],
    },
    {
      key: 'scenarioC',
      steps: [
        {
          key: 'stepC1',
          withNextSteps: false,
          withBullets: [
            {
              key: 'bullet1',
              goTo: 'stepC2',
            },
            {
              key: 'bullet2',
              goTo: 'stepC3',
            },
          ],
          image: assets.scenarioCstep1,
          hotspots: [
            { x: 480, y: 642, goTo: 'stepC2' },
            { x: 480, y: 346, goTo: 'stepC3' },
          ],
        },
        {
          key: 'stepC2',
          withBullets: 3,
          video: assets.scenarioCstep2,
        },
        {
          key: 'stepC3',
          withBullets: 3,
          video: assets.scenarioCstep3,
        },
      ],
    },
  ],
};
